// Vendor libraries
import { createReducer, on } from '@ngrx/store';
// Actions
import { createSavedItem, deleteSavedItem, setSavedItems, updateSavedItem, } from 'NewAngular/features/components/saved-items/state/saved-items.actions';
export const savedItems = createReducer({}, on(setSavedItems, (state, action) => {
    const savedItemMap = {};
    action.savedItems.forEach((item) => {
        savedItemMap[item.id] = item;
    });
    return savedItemMap;
}), on(createSavedItem, (state, action) => {
    return { ...state, [action.savedItem.id]: action.savedItem };
}), on(deleteSavedItem, (state, action) => {
    const nextState = { ...state };
    delete nextState[action.savedItemId];
    return nextState;
}), on(updateSavedItem, (state, action) => {
    return { ...state, [action.savedItem.id]: action.savedItem };
}));
